<ng-template #displayTemplateRef
             let-rowData>
  @if (actionsTemplate) {
    <div class="sc-table-action-buttons w-full flex justify-content-end">
      <ng-container>
        <ng-template *ngTemplateOutlet="actionsTemplate; context: {$implicit: rowData}"></ng-template>
      </ng-container>
    </div>
  }
</ng-template>